<template lang="html">
  <div class="">
    <search-form @search="search" :ruleForm="ruleForm" />
    <flowing-water-table ref="flowingWaterTable" :ruleForm="ruleForm" />
  </div>
</template>

<script>
import searchForm from "./components/searchForm";
import flowingWaterTable from "./components/flowingWaterTable";
export default {
  data() {
    return {
      ruleForm: {
        createTime: [],
        totalMoney: {
          type: 0,
          start: "",
          end: ""
        }
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    search() {
      this.$refs.flowingWaterTable.getDataList(true);
    }
  },
  watch: {},
  components: {
    searchForm,
    flowingWaterTable
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/flowingWater/index.vue